import { GeneralFilter } from '../Common/common-filter';

export class Job {

  Title: string; //UD
  Status: number;//0 (just in)/1 (started/restarted)/2 (ended)/-1 (paused) //SC
  CRName: string; //UD
  CRGroupOrNot: string; //UD
  Description: string; //UD
  FilterFromDB: string; //UD
  CallIDValue: string; //UD
  DeviceIDValue: string; //UD
  TotalNoofTimes: number;//1/multi/0/-1(infinite) = Once/Multi/End by/Indefinite //UD
  EndBy: string;//Date = Above once or Report gen ends on specified date //UD
  ifToBeRecurred: number;//0-5, None, Hourly, etc //UD
  Months: Array<number>; //Yearly //UD
  Days: Array<number>; //Weekly //UD
  DaysOnEvery: number; //nth week for each weekday //UD
  Dates: Array<number>; //Monthly Or Yearly(only one date in common) //UD
  Hours: number; //UD
  Minutes: number; //UD
  DurationTypeFilter: number; //UD-Based on Duration Or TS Filter dates inputs BLANK or NOT BLANK
  TimeDiffFilter: string;//Days+hrs+Mins from now //UD
  startTimestampFilter: string;//Query Filter start date //UD
  endTimestampFilter: string;//Query Filter end date //UD
  TimestampTypeFilter: string; //UD

  ExportTypes: Array<number>; //UD

  SaveToDirOrSend: Array<number>; //UD
  WebviewerDirPath: string; //UD
  EmailSubject: string; //UD
  SMSSubject: string; //UD
  AllContactsUnderRep: Array<string>; //UD

  ClientTimeStamp: string;//Current datetime sent by VQuad or Webview //UD

  InsertOrUpdateJob: number;

  DataImportOrWebview: number;

  WebviewConfigUpdated: number;
  DBType: string;
  OracleHost: string;
  OracleUN: string;
  OraclePWD: string;
  OraclePort: string;
  OracleIP: string;
  MDBPath: string;
  OutputGPS: string;
  DB_BRDiff: string;
  generalFilterArray: Array<GeneralFilter>;
  constructor() {
    this.generalFilterArray = [];
  }
}
